export const Props = () => ({
  //----------------------------------------------------------------------------
  //                         Ссылка на изобаржение иконки реакции
  //----------------------------------------------------------------------------
  icon: {
    type: String,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                                    Счетчик
  //----------------------------------------------------------------------------
  count: {
    type: Number,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                                Кнопка активна?
  //----------------------------------------------------------------------------
  isActive: {
    type: Boolean,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});